import React from "react";

export default function CoreIFrame(props) {
  const { src, title = "Invoice", ...restProps } = props;
  return <iframe src={src} title={title} {...restProps} />;
}
